import { z } from "zod";

/**
 * Admin/reindex operations
 * ReindexAll, GetReindexStatus
 */

export const DocumentTemplateReindexResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  stats: z.object({
    total: z.number(),
    indexed: z.number(),
    skipped: z.string(),
    failed: z.number()
  })
});

export const DocumentTemplateReindexStatusResponseSchema = z.object({
  total: z.number(),
  readyToIndex: z.number(),
  missingDescription: z.number(),
  indexEnabled: z.boolean()
});
